import { Title } from "@abb/arcadia-ui-react"

export function HomeContainer() {
  return (
    <div>
      <Title textElement={<div className="title">{<p>Home</p>}</div>} />
    </div>
  )
}
